import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import cn from 'classnames';
import { BUTTON_TYPES } from 'wix-rich-content-editor-common';
import IconButton from '../../../Button/IconButton';
import s from './ExternalToolbar.scss';
const Button = ({ onClick, getIcon, dataHook, isDisabled, isActive, tooltip, withTooltip, onPluginClick })=>{
    const Icon = getIcon();
    return /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled(),
        "data-hook": dataHook,
        onClick: (e)=>{
            onPluginClick && onPluginClick();
            onClick(e);
        },
        "aria-label": tooltip,
        tooltipText: withTooltip ? tooltip : undefined,
        className: cn(s['button'], s[`button-${dataHook}`])
    }, /*#__PURE__*/ React.createElement(Icon, {
        disableDefaultColors: true
    }));
};
const ExternalToolbar = ({ buttons, className, withTooltips = true, onPluginClick })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['wrapper'], className)
    }, Object.values(buttons).map((buttonProps)=>buttonProps.type === BUTTON_TYPES.FILE ? null : /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({
            key: buttonProps.dataHook,
            withTooltip: withTooltips
        }, buttonProps), {
            onPluginClick: onPluginClick
        }))));
};
ExternalToolbar.displayName = 'ExternalToolbar';
export default ExternalToolbar;

//# sourceMappingURL=ExternalToolbar.js.map